import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import { StyledIcon } from './Icon.styled';
import type { IconComponent, IconProps } from './Icon.types';

export const Icon: IconComponent = forwardRef(
  <C extends ElementType = 'span'>({ source, ...props }: IconProps<C>, ref: PolymorphicRef<C>) => {
    return <StyledIcon as={source} {...props} ref={ref} />;
  },
);
